import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./my_event.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import { Form } from "antd";
import PPKMLogo from "../../../images/ppkmLogo.jpg";
import getEventController from "../Controller/getEvent_controller";
import SearchBar from "../../../components/SearchBox/searchbox.js";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const MyEvent = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const userID = localStorage.getItem("userId");
  const memberID = localStorage.getItem("memberId");
  // console.log(userID);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [page, setPage] = React.useState(0);
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [open, setOpen] = useState(false); // State for modal
  const [form] = Form.useForm();
  const [MyUpcomingEvents, setMyUpcomingEvents] = useState([]);
  const [MyPastEvents, setMyPastEvents] = useState([]);
  const [MyEventRegistrations, setMyEventRegistrations] = useState([]);
  const [filteredMyUpcomingEvents, setFilteredMyUpcomingEvents] = useState([]);
  const [filteredMyPastEvents, setFilteredMyPastEvents] = useState([]);
  const [filteredMyEventRegistrations, setFilteredMyEventRegistrations] =
    useState([]);
  const [selectedEventRegistrationData, setselectedEventRegistrationData] =
    useState(null); // User data from the database

  useEffect(() => {
    // Fetch both upcoming and past events
    Promise.all([
      getEventController.getUserUpcomingEventRegistrations(memberID),
      getEventController.getUserPastEventRegistrations(memberID),
    ]).then(([upcomingResponse, pastResponse]) => {
      if (Array.isArray(upcomingResponse)) {
        setMyUpcomingEvents(formatEvents(upcomingResponse));
      }
      if (Array.isArray(pastResponse)) {
        setMyPastEvents(formatEvents(pastResponse));
        console.log(pastResponse);
      }
    });
  }, []);

  const formatEvents = (events) => {
    return events.map((item) => {
      const isValidDate = (date) =>
        date && date !== "0000-00-00" && !isNaN(new Date(date).getTime());

      const startDate = isValidDate(item.event_start_date)
        ? new Date(item.event_start_date)
        : null;
      const endDate = isValidDate(item.event_end_date)
        ? new Date(item.event_end_date)
        : null;

      const dateFormatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      return {
        id: item.eventID,
        imgSrc: item.event_poster,
        title: item.event_name || "Untitled Event",
        startdate: startDate
          ? dateFormatter.format(startDate)
          : "Date not available",
        enddate: endDate ? dateFormatter.format(endDate) : "",
        venue: item.event_venue || "Venue not specified",
        category: item.event_category_name || "Untitled Category",
      };
    });
  };

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setFilteredMyUpcomingEvents(MyUpcomingEvents);
      setFilteredMyPastEvents(MyPastEvents);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();

      setFilteredMyUpcomingEvents(
        MyUpcomingEvents.filter(
          (event) =>
            event.title.toLowerCase().includes(lowercasedTerm) ||
            event.venue.toLowerCase().includes(lowercasedTerm)
        )
      );

      setFilteredMyPastEvents(
        MyPastEvents.filter(
          (event) =>
            event.title.toLowerCase().includes(lowercasedTerm) ||
            event.venue.toLowerCase().includes(lowercasedTerm)
        )
      );
    }
  };

  useEffect(() => {
    setFilteredMyUpcomingEvents(MyUpcomingEvents);
  }, [MyUpcomingEvents]);

  useEffect(() => {
    setFilteredMyPastEvents(MyPastEvents);
  }, [MyPastEvents]);

  useEffect(() => {
    getEventController
      .getMemberEventRegistrations(memberID)
      .then((response) => {
        if (response) {
          const formatDate = (dateTimeString) => {
            if (!dateTimeString) return "Date not available"; // Handle missing values

            const datePart = dateTimeString.split(" ")[0]; // Extract "YYYY-MM-DD"
            const [year, month, day] = datePart.split("-"); // Split into components

            return `${day}/${month}/${year}`; // Format as "DD/MM/YYYY"
          };

          const statusMapping = {
            0: "Pending",
            1: "Paid",
            2: "Unpaid",
          };

          // Map the API response to rows
          const fetchedRows = response.map((item, index) => ({
            number: index + 1, // Sequential number
            registrationID: item.event_registrationID,
            event_name: item.event_name,
            register_date: formatDate(item.datetime_created), // Format date
            invoice_no: item.invoice_no,
            status: statusMapping[item.status] || "Unknown", // Default to "Unknown"
            details: item.event_registrationID || "No additional details", // Store details
          }));
          setRows(fetchedRows);
        }
      })
      .catch((error) => {
        console.error("Error fetching event data:", error);
      });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpen = (registrationID) => {
    // setSelectedDetails(paymentID); // Set the details of the clicked row
    setOpen(true);
    console.log(registrationID);

    //get Payment Info by paymentId
    getEventController
      .getEventRegistrationInfo(registrationID)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          const statusMap = {
            0: "Pending",
            1: "Paid",
            2: "Unpaid",
          };

          setselectedEventRegistrationData({
            registrationID: response.event_registrationID,
            event_name: response.event_name,
            invoice_no: response.invoice_no,
            status: statusMap[response.status] || "Unknown", // Default to "Unknown"
            billing_name: response.billing_name,
            billing_address: response.billing_address,
            e_invoice_pin: response.e_invoice_pin,
            contact_name: response.contact_name,
            contact_phone_no: response.contact_hp,
            contact_email: response.contact_email,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };

  const handleClose = () => {
    setselectedEventRegistrationData(null);
    setOpen(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    height: "auto",
    bgcolor: "background.paper",
    borderRadius: "25px",
    boxShadow: 24,
    p: 4,
  };

  const handleEventClick = (eventId) => {
    navigate(`/view_event/${eventId}`);
  };

  //Tab 3: Event Registrations Columns
  const columns = [
    { id: "number", label: "No.", minWidth: 50, align: "center" },
    {
      id: "registrationID",
      label: "Registration No.",
      minWidth: 150,
      align: "center",
    },
    { id: "event_name", label: "Event Title", minWidth: 300, align: "center" },
    {
      id: "register_date",
      label: "Registered Date",
      minWidth: 200,
      align: "center",
    },
    { id: "invoice_no", label: "Invoice No.", minWidth: 150, align: "center" },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
      align: "center",
    },
    {
      id: "details",
      label: "Details",
      minWidth: 100,
      align: "center",
    },
  ];

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="my-event-list">
          {/*Search Bar */}
          <div className="row-1 ">
            <Grid className="sec_grid" container spacing={2}>
              <Grid size={12}>
                <TextField
                  className="searchbar"
                  label="Search"
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <IconButton
                          type="button"
                          aria-label="search"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          {/*Tab Divider: Upcoming and Past*/}
          <div>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box className="event-label-box">
                  <TabList
                    onChange={handleChange}
                    textColor="black"
                    TabIndicatorProps={{ sx: { backgroundColor: "black" } }}
                    sx={{
                      "& .MuiTabs-flexContainer": {
                        justifyContent: "space-around", // This targets the flex container inside TabList
                      },
                    }}
                  >
                    <Tab label="Upcoming" value="1" />
                    <Tab label="Past" value="2" />
                  </TabList>
                </Box>
                {/*Upcoming Tab */}
                <TabPanel value="1">
                  <div className="event-card-row mt-2">
                    <CardActionArea
                      sx={{ maxWidth: 420 }}
                      onClick={() => navigate("/view_event")}
                    >
                      <Card
                        sx={{ maxWidth: 420, boxShadow: 5 }}
                        className="d-flex event-card"
                      >
                        <CardContent>
                          <div className="event-card-content">
                            <img src={Event1} className="event-poster" />
                            <div className="text-content">
                              <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                                SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION
                                SEMINARS (SMMCES)
                              </Typography>
                              <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                                9-11 August 2024, JW Marriott Kuala Lumpur
                              </Typography>
                            </div>
                            <NavigateNextIcon className="event-icon" />
                          </div>
                        </CardContent>
                      </Card>
                    </CardActionArea>
                  </div>
                </TabPanel>
                {/*Past Tab */}
                <TabPanel value="2">
                  <div className="event-card-row mt-2">
                    <CardActionArea sx={{ maxWidth: 420 }}>
                      <Card
                        sx={{ maxWidth: 420, boxShadow: 5 }}
                        className="d-flex event-card"
                      >
                        <CardContent>
                          <div className="event-card-content">
                            <img src={Event1} className="event-poster" />
                            <div className="text-content">
                              <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                                SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION
                                SEMINARS (SMMCES)
                              </Typography>
                              <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                                9-11 August 2024, JW Marriott Kuala Lumpur
                              </Typography>
                            </div>
                            <NavigateNextIcon className="event-icon" />
                          </div>
                        </CardContent>
                      </Card>
                    </CardActionArea>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
          {/*Event Card */}
          {/* <div className="event-card-row mt-2">
      <CardActionArea sx={{ maxWidth: 420 }}>
        <Card
          sx={{ maxWidth: 420, boxShadow: 5 }}
          className="d-flex event-card"
        >
          <CardContent>
            <div className="event-card-content">
              <img src={Event1} className="event-poster" />
              <div className="text-content">
                <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                  SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION SEMINARS
                  (SMMCES)
                </Typography>
                <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                  9-11 August 2024, JW Marriott Kuala Lumpur
                </Typography>
              </div>
              <NavigateNextIcon className="event-icon" />
            </div>
          </CardContent>
        </Card>
      </CardActionArea>
    </div> */}
        </div>
      ) : (
        <div className="my-event-wrapper">
          <div className="my-event-list">
            <span className="my-event-title">
              {/* <IoMdHome /> */}
              My Events
            </span>

            {/*Search Bar */}
            <SearchBar onSearch={handleSearch} />

            {/*Tab Divider: Upcoming and Past*/}
            <div>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box className="event-label-box">
                    <TabList
                      onChange={handleChange}
                      textColor="black"
                      TabIndicatorProps={{ sx: { backgroundColor: "black" } }}
                      sx={{
                        "& .MuiTabs-flexContainer": {
                          justifyContent: "space-around", // This targets the flex container inside TabList
                        },
                      }}
                    >
                      <Tab label="Current" value="1" />
                      <Tab label="Past" value="2" />
                      <Tab label="Event Registrations" value="3" />
                    </TabList>
                  </Box>
                  {/*Current/Upcoming Tab */}
                  <TabPanel value="1">
                    {/* Display message if no upcoming events */}
                    {filteredMyUpcomingEvents.length === 0 ? (
                      <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <p>There're no current / upcoming event(s) found</p>
                      </div>
                    ) : (
                      <Box sx={{ width: "100%", typography: "body1" }}>
                        <Grid
                          container
                          spacing={2}
                          sx={{ justifyContent: "center", margin: "10px" }}
                        >
                          {filteredMyUpcomingEvents.map((event, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              key={index}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Form form={form} component={false}>
                                <Paper
                                  sx={(theme) => ({
                                    display: "flex",
                                    height: "250px",
                                    width: "450px",
                                    marginTop: "20px",
                                    backgroundColor: "#fff",
                                    ...theme.applyStyles("dark", {
                                      backgroundColor: "#1A2027",
                                    }),
                                    boxShadow: 5,
                                    justifyContent: "flex-start",
                                    borderRadius: "15px",
                                    cursor: "pointer",
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                      transform: "scale(1.05)",
                                      boxShadow: 10,
                                    },
                                  })}
                                  onClick={() => handleEventClick(event.id)}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      padding: "10px",
                                    }}
                                    id={event.id}
                                  >
                                    {/* Poster Image */}
                                    <img
                                      src={
                                        event.imgSrc &&
                                        event.imgSrc.trim() !== ""
                                          ? event.imgSrc
                                          : PPKMLogo
                                      }
                                      alt={event.title}
                                      className="upcoming-event-poster"
                                    />

                                    {/* Event Info */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {/* Title next to the image */}
                                      <span className="event-title">
                                        {event.title}
                                      </span>

                                      {/* Date and Venue below the title */}
                                      <div className="event-date-venue">
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <CalendarMonthIcon className="de-icon" />
                                          {event.startdate} - {event.enddate}
                                        </span>
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <PinDropIcon className="de-icon" />
                                          {event.venue}
                                        </span>
                                        {/* <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <CategoryOutlinedIcon className="de-icon" />
                                          {event.category}
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>
                                </Paper>
                              </Form>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    )}
                  </TabPanel>
                  {/*Past Tab */}
                  <TabPanel value="2">
                    {/* Display message if no upcoming events */}
                    {filteredMyPastEvents.length === 0 ? (
                      <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <p>There're no past event(s) found</p>
                      </div>
                    ) : (
                      <Box sx={{ width: "100%", typography: "body1" }}>
                        <Grid
                          container
                          spacing={2}
                          sx={{ justifyContent: "center", margin: "10px" }}
                        >
                          {filteredMyPastEvents.map((event, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              key={index}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Form form={form} component={false}>
                                <Paper
                                  sx={(theme) => ({
                                    display: "flex",
                                    height: "250px",
                                    width: "450px",
                                    marginTop: "20px",
                                    backgroundColor: "#fff",
                                    ...theme.applyStyles("dark", {
                                      backgroundColor: "#1A2027",
                                    }),
                                    boxShadow: 5,
                                    justifyContent: "flex-start",
                                    borderRadius: "15px",
                                    cursor: "pointer",
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": {
                                      transform: "scale(1.05)",
                                      boxShadow: 10,
                                    },
                                  })}
                                  onClick={() => handleEventClick(event.id)}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      padding: "10px",
                                    }}
                                    id={event.id}
                                  >
                                    {/* Poster Image */}
                                    <img
                                      src={
                                        event.imgSrc &&
                                        event.imgSrc.trim() !== ""
                                          ? event.imgSrc
                                          : PPKMLogo
                                      }
                                      alt={event.title}
                                      className="upcoming-event-poster"
                                    />

                                    {/* Event Info */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {/* Title next to the image */}
                                      <span className="event-title">
                                        {event.title}
                                      </span>

                                      {/* Date and Venue below the title */}
                                      <div className="event-date-venue">
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <CalendarMonthIcon className="de-icon" />
                                          {event.startdate} - {event.enddate}
                                        </span>
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <PinDropIcon className="de-icon" />
                                          {event.venue}
                                        </span>
                                        {/* <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <CategoryOutlinedIcon className="de-icon" />
                                          {event.category}
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>
                                </Paper>
                              </Form>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    )}
                  </TabPanel>
                  {/*Event Registration Tab */}
                  <TabPanel value="3">
                    {/* Display message if no upcoming events */}
                    {/* {filteredMyEventRegistrations.length === 0 ? (
                      <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <p>There're no event registration(s) found</p>
                      </div>
                    ) : ( */}
                    <Box sx={{ width: "100%", typography: "body1" }}>
                      <Grid
                        container
                        spacing={2}
                        sx={{ justifyContent: "center", margin: "10px" }}
                      >
                        {/* {filteredMyEventRegistrations.map((event, index) => ( */}
                        {/* renewal history */}
                        <div className="mt-4">
                          <Paper
                            sx={{
                              width: "100%",
                              overflow: "hidden",
                              boxShadow: 5,
                            }}
                          >
                            <TableContainer sx={{ maxHeight: 440 }}>
                              <Table>
                                <TableHead
                                  sx={{
                                    backgroundColor: "lightgrey",
                                  }}
                                >
                                  <TableRow>
                                    {columns.map((column) => (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{
                                          minWidth: column.minWidth,
                                          fontSize: "15px",
                                          fontWeight: "bold",
                                          padding: "10px",
                                        }}
                                      >
                                        {column.label}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {rows
                                    .slice(
                                      page * rowsPerPage,
                                      page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row) => {
                                      return (
                                        <TableRow
                                          role="checkbox"
                                          tabIndex={-1}
                                          key={row.number}
                                        >
                                          {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                              <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{
                                                  fontSize: "15px",
                                                  padding: "10px",
                                                }}
                                              >
                                                {column.id === "details" ? (
                                                  <IconButton
                                                    color="primary"
                                                    onClick={() =>
                                                      handleOpen(value)
                                                    } // Pass the details to the modal
                                                  >
                                                    <InfoIcon />
                                                  </IconButton>
                                                ) : (
                                                  value
                                                )}
                                              </TableCell>
                                            );
                                          })}
                                        </TableRow>
                                      );
                                    })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            <TablePagination
                              component="div"
                              count={rows.length} // Total number of rows
                              rowsPerPage={rowsPerPage} // Fixed rows per page
                              page={page}
                              onPageChange={handleChangePage}
                              rowsPerPageOptions={[]} // Hide rows-per-page dropdown
                              labelDisplayedRows={({ from, to, count }) =>
                                `${from}-${to} of ${
                                  count !== -1 ? count : `more than ${to}`
                                }`
                              }
                            />

                            <Modal
                              open={open}
                              onClose={handleClose}
                              closeAfterTransition
                              BackdropProps={{
                                onClick: (e) => e.stopPropagation(), // Prevent backdrop click
                              }}
                            >
                              <Box sx={{ ...modalStyle, position: "relative" }}>
                                {/* Close Button */}
                                <IconButton
                                  onClick={handleClose}
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>

                                {/* Modal Content */}
                                <Typography
                                  sx={{
                                    fontSize: "30px",
                                    fontWeight: "bold",
                                    color: "#b24743",
                                    marginBottom: "15px",
                                  }}
                                >
                                  Registration Info
                                </Typography>
                                {selectedEventRegistrationData ? (
                                  <div className="selected_payment_details">
                                    {/* Registration No */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Registration No.</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.registrationID
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Event Title */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Event Title</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.event_name
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Payment Invoice No. */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Payment Invoice No.</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.invoice_no
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Payment Status */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Payment Status</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {selectedEventRegistrationData.status}
                                        </span>
                                      </div>
                                    </div>
                                    {/* Billing Name */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Billing Name</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.billing_name
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Billing Address */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Billing Address</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.billing_address
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* E-Invoice Pin /Tin No. */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>E-Invoice Pin /Tin No.</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.e_invoice_pin
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Contact Person Name */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Contact Person's Name</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.contact_name
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Contact Person Mobile No. */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Contact Person's Mobile No.</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.contact_phone_no
                                          }
                                        </span>
                                      </div>
                                    </div>
                                    {/* Contact Person Email */}
                                    <div className="col-md-12 row">
                                      <div className="col-md-5 payment_details_label">
                                        <span>Contact Person's Email</span>
                                      </div>
                                      <div className="col-md-7 payment_details_data">
                                        <span>
                                          :{" "}
                                          {
                                            selectedEventRegistrationData.contact_email
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <Typography>Loading...</Typography>
                                )}
                              </Box>
                            </Modal>
                          </Paper>
                        </div>
                        {/* // ))} */}
                      </Grid>
                    </Box>
                    {/* )} */}
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
            {/*Event Card */}
            {/* <div className="event-card-row mt-2">
          <CardActionArea sx={{ maxWidth: 420 }}>
            <Card
              sx={{ maxWidth: 420, boxShadow: 5 }}
              className="d-flex event-card"
            >
              <CardContent>
                <div className="event-card-content">
                  <img src={Event1} className="event-poster" />
                  <div className="text-content">
                    <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                      SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION SEMINARS
                      (SMMCES)
                    </Typography>
                    <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                      9-11 August 2024, JW Marriott Kuala Lumpur
                    </Typography>
                  </div>
                  <NavigateNextIcon className="event-icon" />
                </div>
              </CardContent>
            </Card>
          </CardActionArea>
        </div> */}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MyEvent;
